<template>
  <div
    class="cat-item mb-1"
    @click="orderItem"
  >
    <v-container :style="myContainerStyle">
      <v-layout
        row
        align-center
      >
        <v-avatar
          size="72"
          tile
        >
          <img class="food-img" :src="itemImage">
        </v-avatar>
        <v-flex ml-3>
          <v-layout
            row
            align-center
          >
            <v-flex xs12>
              <span class="name">{{ itemName }}</span>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex
              v-if="catItem.displayDesc && item.description"
              xs12
              class="description nowrap-text"
            >
              {{ item.description }}
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'simple-cat-item-component',
  props: {
    item: {
      type: Object,
      default: () => null
    },
    multiplePlus: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapGetters('config', [
      'config', 'theme', 'catItem', 'language', 'mode'
    ]),
    myContainerStyle () {
      return {
        padding: '6px 15px'
      }
    },
    itemName () {
      let name
      if (this.language !== 'en-SG') {
        name = this.item.alternate_name || this.item.name
        if (this.multiplePlus) name += ' (' + (this.item.portion_size_alternatename ? this.item.portion_size_alternatename : this.item.portion_size_name) + ')'
      } else {
        name = this.item.name
        if (this.multiplePlus) name += ' (' + this.item.portion_size_name + ')'
      }
      return name
    },
    itemImage () {
      return this.item.photo_url ? this.item.photo_url : window.config.sharedPictures + 'food_image.png'
    },
  },
  methods: {
    orderItem () {
      this.$store.dispatch('menu/showMenuItemDialog', this.item)
    }
  }
}
</script>

<style scoped>
.name {
  font-size: 15px;
  font-weight: 700;
}
.description {
  font-size: 14px;
  color: #7d7d7d;
  font-weight: 700;
}
.cat-item {
  font-size: 17px;
  min-height: 40px;
  cursor: pointer;
}
.food-img {
  border-radius: 5px;
  object-fit: cover;
}
.nowrap-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/SimpleCatItem.vue